import { getCompanyDetailsApi, updateCompanySetting } from '_services';
import { UserContext } from 'context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Accordion } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { HiChevronDown } from "react-icons/hi2";
import StorageService from 'utils/StorageServices';

const status = [
    { title: "Available", value: "available" },
    { title: "Not Available", value: "not_available" },
    { title: "premium", value: "premium" },
    { title: "Coming soon", value: "coming_soon" }

]

const CompanySetting = ({ setActiveTab }) => {
    const initialFormValues = {
        company_id: StorageService.getCompanyId(),
        perms_supplier: {
            pan_mandatory: false,
            pan_attach_mandatory: false
        },
        perms_own_driver: {
            license_no: false,
            license_attach: false,
            aadhar_no: false,
            aadhar_attach: false
        },
        perms_market_driver: {
            license_no: false,
            license_attach: false,
            aadhar_no: false,
            aadhar_attach: false
        },
        perms_market_vehicle: {
            doc_check_trip: false,
            doc_expiry_check_trip: false,
            auto_update_doc: false,
            documents: []
        },
        perms_own_vehicle: {
            doc_check_trip: false,
            doc_expiry_check_trip: false,
            auto_update_doc: false,
            documents: []
        }
    };


    const [form, setForm] = useState(initialFormValues);
    const [updateLoading, setUpdateLoading] = useState(false)
    const originalFormRef = useRef(null);
    const [disableButton, setDisableButton] = useState(true);
    const [settingPermission, setSettingPermission] = useState([]);


    useEffect(() => {
        if (originalFormRef.current) {
            const isSame = JSON.stringify(originalFormRef.current) === JSON.stringify(form);
            setDisableButton(isSame); // true = disable button, false = enable
        }
    }, [form]);

    useEffect(() => {
        getComapnyDetailsHandle();
    }, []);

    const getComapnyDetailsHandle = async () => {
        try {
            const res = await getCompanyDetailsApi({ company_id: StorageService.getCompanyId() });
            const companyDetails = res?.data?.company;
            const findDetails = companyDetails?.subscription_data?.company_settings.find((s) => s?.sort == 1)
            setSettingPermission(findDetails?.permissions)

            // Ensure documents arrays are properly initialized
            const normalizedDetails = {
                ...companyDetails,
                perms_market_vehicle: {
                    ...companyDetails.perms_market_vehicle,
                    documents: companyDetails.perms_market_vehicle.documents || []
                },
                perms_own_vehicle: {
                    ...companyDetails.perms_own_vehicle,
                    documents: companyDetails.perms_own_vehicle.documents || []
                }
            };

            const formattedData = {
                ...companyDetails,
                company_id: normalizedDetails._id,
                perms_supplier: normalizedDetails.perms_supplier,
                perms_own_driver: normalizedDetails.perms_own_driver,
                perms_market_driver: normalizedDetails.perms_market_driver,
                perms_market_vehicle: normalizedDetails.perms_market_vehicle,
                perms_own_vehicle: normalizedDetails.perms_own_vehicle
            }

            originalFormRef.current = formattedData;
            setForm(formattedData)
            // setForm(prev => ({

            // }));



            // setDisableButton(true);

        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    }

    const handleUpdate = async () => {
        setUpdateLoading(true)
        try {
            const response = await updateCompanySetting(form)

            if (response?.responseCode == 200) {
                setUpdateLoading(false)
                getComapnyDetailsHandle()
                toast.success(response?.responseMessage || "Update Successfully")
            } else {
                setUpdateLoading(false)
                toast.error(response?.responseMessage || "Something is wrong")
            }

        } catch (error) {
            setUpdateLoading(false)
            toast.success(error)
        }
    }

    return (
        <>
            <DynamicSettingsForm form={form} setForm={setForm} settingPermission={settingPermission} />
            <div className='__setFooter'>
                <button className={`__setBtn ${(updateLoading) ? "__setBtn_cancel" : "__setBtn_update"}`} disabled={updateLoading} onClick={(event) => handleUpdate(event)}>
                    {updateLoading ? "Updating..." : "Update"}
                </button>
                <button className='__setBtn __setBtn_cancel' onClick={getComapnyDetailsHandle}>Cancel</button>
            </div>
        </>
    )
}

export default CompanySetting;

const DynamicSettingsForm = ({ form, setForm, settingPermission }) => {

    const { masterData } = useContext(UserContext)

    const sectionConfig = {
        perms_supplier: {
            title: "SUPPLIER",
            fields: [
                {
                    name: "pan_mandatory",
                    label: "Supplier PAN Mandatory",
                    type: "radio"
                },
                {
                    name: "pan_attach_mandatory",
                    label: "PAN Attachment Mandatory",
                    type: "radio"
                }
            ]
        },
        perms_own_driver: {
            title: "OWN DRIVER",
            fields: [
                {
                    name: "license_no",
                    label: "License Number",
                    type: "radio"
                },
                // {
                //     name: "license_attach",
                //     label: "License Attachment",
                //     type: "radio"
                // },
                {
                    name: "aadhar_no",
                    label: "Aadhar Number",
                    type: "radio"
                },
                // {
                //     name: "aadhar_attach",
                //     label: "Aadhar Attachment",
                //     type: "radio"
                // }
            ]
        },
        perms_market_driver: {
            title: "MARKET DRIVER",
            fields: [
                {
                    name: "license_no",
                    label: "Market Driver License Number",
                    type: "radio"
                },
                // {
                //     name: "license_attach",
                //     label: "Market Driver License Attachment",
                //     type: "radio"
                // },
                {
                    name: "aadhar_no",
                    label: "Market Driver Aadhar Number",
                    type: "radio"
                },
                // {
                //     name: "aadhar_attach",
                //     label: "Market Driver Aadhar Attachment",
                //     type: "radio"
                // }
            ]
        },
        perms_market_vehicle: {
            title: "MARKET VEHICLE",
            fields: [
                {
                    name: "doc_check_trip",
                    label: "Market Vehicle Document Check on Trip",
                    type: "radio",
                    yesNo: true
                },
                {
                    name: "auto_update_doc",
                    label: "Auto Update document at adding New Vehicle",
                    type: "radio",
                    yesNo: true
                },
                {
                    name: "doc_expiry_check_trip",
                    label: "Market Vehicle Document Expiry check on Trip",
                    type: "radio"
                },

                {
                    name: "documents",
                    label: "Documents",
                    type: "checkbox",

                    options: masterData?.own_vehicle_documents
                }
            ]
        },
        perms_own_vehicle: {
            title: "OWN/LEASED VEHICLE",
            fields: [
                {
                    name: "doc_check_trip",
                    label: "Own Vehicle Document Check on Trip",
                    type: "radio",
                    yesNo: true
                },
                {
                    name: "auto_update_doc",
                    label: "Auto Update document at adding New Vehicle",
                    type: "radio",
                    yesNo: true
                },
                {
                    name: "doc_expiry_check_trip",
                    label: "Own Vehicle Document Expiry check on Trip",
                    type: "radio"
                },
                {
                    name: "documents",
                    label: "Documents",
                    type: "checkbox",

                    options: masterData?.own_vehicle_documents
                }
            ]
        }
    };

    const [activeKeys, setActiveKeys] = useState([]);
    const getChevronRotation = () => {
        if (allOpen) return "180deg";
        if (allClosed) return "0deg";
        return "90deg";
    };


    useEffect(() => {
        const vehicleSections = ['perms_market_vehicle', 'perms_own_vehicle'];
        vehicleSections.forEach(section => {
            if (form[section]?.doc_expiry_check_trip === false && form[section]?.documents?.length > 0) {
                setForm(prev => ({
                    ...prev,
                    [section]: {
                        ...prev[section],
                        documents: []
                    }
                }));
            }
        });
    }, [form.perms_market_vehicle.doc_expiry_check_trip, form.perms_own_vehicle.doc_expiry_check_trip]);

    const handleRadioChange = (section, field, value) => {
        setForm(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleCheckboxChange = (section, field, option, isChecked) => {
        setForm(prev => {
            const currentIds = [...prev[section][field]];

            if (isChecked) {
                if (!currentIds.includes(option.id)) {
                    currentIds.push(option.id);
                }
            } else {
                const index = currentIds.indexOf(option.id);
                if (index > -1) {
                    currentIds.splice(index, 1);
                }
            }

            return {
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: currentIds
                }
            };
        });
    };

    const getStatusTitle = (item) => {
        const statusItem = status.find((st) => item[st.value] === 1);
        return statusItem ? statusItem.title : "";
    };

    const updatedSectionConfig = Object.keys(sectionConfig).reduce((acc, key) => {
        const section = sectionConfig[key];
        const matchedPermission = settingPermission?.find((p) => p.name === section.title);
        acc[key] = {
            ...section,
            status: matchedPermission ? getStatusTitle(matchedPermission) : "",
        };
        return acc;
    }, {});

    const allowedSections = Object.keys(updatedSectionConfig)
        .map((sectionKey, idx) => {
            const section = updatedSectionConfig[sectionKey];
            const perm = settingPermission.find((p) => p.name === section.title);
            // Not Available ko hide karo, baaki sab dikhaao
            return (perm?.web === 1 && section.status !== "Not Available") ? String(idx) : null;
        })
        .filter(Boolean);


    useEffect(() => {
        setActiveKeys(allowedSections);
    }, [settingPermission]);


    const allOpen = activeKeys.length === allowedSections.length;
    const allClosed = activeKeys.length === 0;


    const toggleAllAccordions = () => {
        if (allOpen) {
            setActiveKeys([]);
        } else {
            setActiveKeys(allowedSections);
        }
    };

    const handleAccordionToggle = (eventKey) => {
        const isAllowed = allowedSections.includes(eventKey);
        if (!isAllowed) return;

        if (activeKeys.includes(eventKey)) {
            setActiveKeys(activeKeys.filter((key) => key !== eventKey));
        } else {
            setActiveKeys([...activeKeys, eventKey]);
        }
    };

    const renderField = (sectionKey, field) => {
        const sectionData = form[sectionKey];
        const fieldValue = sectionData[field.name];

        if (field.name === "documents" && sectionData.doc_expiry_check_trip === false) {
            return null;
        }


        if (field.type === "radio") {
            return (
                <div className='__setf_branc_sepBx'>
                    <h4>{field.label}</h4>
                    <div className='_flxOtr'>
                        <div className="_dualCheckr_bx">
                            <input
                                className="form-check-input"
                                id={`${sectionKey}_${field.name}_yes`}
                                type="radio"
                                name={`${sectionKey}_${field.name}`}
                                checked={fieldValue === true}
                                onChange={() => handleRadioChange(sectionKey, field.name, true)}
                            />
                            <label
                                htmlFor={`${sectionKey}_${field.name}_yes`}
                                className="form-check-label"
                            >
                                {field.yesNo ? "Yes" : "Mandatory"}
                            </label>
                        </div>

                        <div className="_dualCheckr_bx">
                            <input
                                className="form-check-input"
                                id={`${sectionKey}_${field.name}_no`}
                                type="radio"
                                name={`${sectionKey}_${field.name}`}
                                checked={fieldValue === false}
                                onChange={() => handleRadioChange(sectionKey, field.name, false)}
                            />
                            <label
                                htmlFor={`${sectionKey}_${field.name}_no`}
                                className="form-check-label"
                            >
                                {field.yesNo ? "No" : "Not Mandatory"}
                            </label>
                        </div>
                    </div>
                </div>
            );
        }

        if (field.type === "checkbox") {
            return (
                <div className='__setCheker'>
                    {field.options.map((option) => (
                        <div className="__setCheker_inn" key={option.id}>
                            <input
                                type="checkbox"
                                id={`${sectionKey}_${field.name}_${option.id}`}
                                checked={fieldValue.includes(option.id)} // Check if ID exists
                                onChange={(e) =>
                                    handleCheckboxChange(sectionKey, field.name, option, e.target.checked)
                                }
                            />
                            <label
                                htmlFor={`${sectionKey}_${field.name}_${option.id}`}
                                className="anvLabel"
                            >
                                {option.name}
                            </label>
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Available":
                return "success";
            case "Not Available":
                return "danger";
            case "Premium":
                return "secondary";
            case "Coming Soon":
                return "info";
            default:
                return "secondary";
        }
    };

    return (
        <div className='__stContent'>
            <div className='__setf_brancOtr'>
                <div className='__setf_brancInner'>
                    <div className='__setf_brancBx'>
                        <div
                            className='__setf_brHead'
                            onClick={toggleAllAccordions}
                            style={{ cursor: 'pointer' }}
                        >
                            <h4>Settings for Masters</h4>
                            <span>
                                <HiChevronDown style={{
                                    transform: `rotate(${getChevronRotation()})`,
                                    transition: 'transform 0.3s',
                                    opacity: allOpen || allClosed ? 1 : 0.5
                                }} />
                            </span>
                        </div>

                        <Accordion
                            className='__setingAccordian'
                            activeKey={activeKeys}
                            onSelect={handleAccordionToggle}
                        >
                            {Object.keys(updatedSectionConfig)
                                .filter((sectionKey) => {
                                    const section = updatedSectionConfig[sectionKey];
                                    // Not Available wale sections ko completely hide karo
                                    return section.status !== "Not Available";
                                })
                                .map((sectionKey, idx) => {
                                    const section = updatedSectionConfig[sectionKey];
                                    const perm = settingPermission.find((p) => p.name === section.title);
                                    // Premium aur Coming Soon ko disable karo
                                    const isDisabled = perm?.web !== 1 || section.status === "Premium" || section.status === "Coming Soon";

                                    return (
                                        <Accordion.Item eventKey={String(idx)} key={sectionKey}>
                                            <Accordion.Header style={{
                                                opacity: isDisabled ? 0.5 : 1,
                                                cursor: isDisabled ? "not-allowed" : "pointer",
                                                pointerEvents: isDisabled ? "none" : "auto",
                                            }}>
                                                {section.title}
                                                <span
                                                    style={{
                                                        marginLeft: "10px",
                                                        padding: "5px 10px",
                                                        borderRadius: "12px",
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        textTransform: "uppercase",
                                                        backgroundColor: section.status === "Premium" ? "#6c757d" : 
                                                                       section.status === "Coming Soon" ? "#17a2b8" : 
                                                                       section.status === "Available" ? "#28a745" : 
                                                                       section.status === "Not Available" ? "#dc3545" : "#6c757d",
                                                        color: "#fff"
                                                    }}
                                                >
                                                    {section.status}
                                                </span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                {section.fields.map((field, fieldIdx) => (
                                                    <React.Fragment key={fieldIdx}>
                                                        {renderField(sectionKey, field)}
                                                    </React.Fragment>
                                                ))}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })}
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
};